// extracted by mini-css-extract-plugin
export var actionButton = "_mc-0";
export var actionMenuContainer = "_mc-i";
export var bubble = "_mc-2";
export var bubbleActionMenu = "_mc-j";
export var bubbleContext = "_mc-6";
export var bubbleItems = "_mc-7";
export var customer = "_mc-3";
export var divider = "_mc-8";
export var fileList = "_mc-9";
export var hiddenComment = "_mc-o";
export var infoAbove = "_mc-a";
export var internal = "_mc-4";
export var lightActionButton = "_mc-1";
export var link = "_mc-b";
export var merchant = "_mc-5";
export var message = "_mc-c";
export var profilePicture = "_mc-e";
export var quillToolbarContainer = "_mc-f";
export var senderDate = "_mc-g";
export var senderDateCustomer = "_mc-h";
export var senderName = "_mc-d";
export var time = "_mc-k";
export var uploadedImage = "_mc-l";
export var username = "_mc-m";
export var xsmall = "_mc-n";